import { render, staticRenderFns } from "./ConversationSnapshot.vue?vue&type=template&id=b7ba2466&"
import script from "./ConversationSnapshot.vue?vue&type=script&lang=js&"
export * from "./ConversationSnapshot.vue?vue&type=script&lang=js&"
import style0 from "./ConversationSnapshot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports